import type { ReactNode } from 'react';

/**
 * Cabecalho de pagina.
 *
 * Ele padroniza o que toda tela responde de imediato: onde estou, o que ha aqui e
 * qual e a acao principal. Sem um componente unico, cada modulo inventa a propria
 * hierarquia e a plataforma passa a parecer varios produtos.
 */
export function PageHeader({
  title,
  description,
  actions,
  meta,
}: {
  title: string;
  description?: string | undefined;
  actions?: ReactNode | undefined;
  meta?: ReactNode | undefined;
}) {
  return (
    // As acoes dividem a linha com o titulo enquanto couberem e descem para a linha de
    // baixo quando nao, em vez de empurrar a pagina para o lado.
    <header className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3">
      <div className="min-w-0 flex-[1_1_20rem]">
        <h2 className="truncate text-xl font-semibold tracking-tight text-ink-900">
          {title}
        </h2>
        {description ? (
          // O objeto da operacao pode ser o texto padrao inteiro da modalidade.
          <p className="mt-1 line-clamp-3 text-sm text-ink-500">{description}</p>
        ) : null}
        {meta ? <div className="mt-3 flex flex-wrap gap-2">{meta}</div> : null}
      </div>
      {actions ? (
        <div className="flex max-w-full min-w-0 items-center gap-2">{actions}</div>
      ) : null}
    </header>
  );
}
